<div class="container">
  <h3 class="title">Build In</h3>
  <div>
    <app-server-row
      *ngFor="let server of servers"
      [name]="server.name"
      [type]="server.type"
    ></app-server-row>
  </div>
</div> 